import React, { useCallback, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { FaceitLevel } from "./components/FaceitLevel";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { WatchlistSearch } from "./components/WatchlistSearch";
import { SnackbarProvider, useSnackbar } from "./contexts/SnackbarProvider";
import Play from "./icons/Play";
import WatchlistMobileCard from "./components/WatchlistMobileCard";
import { GuestWatchlistCTA } from "./components/GuestWatchlistCTA";
import { WatchlistPlayer } from "./components/WatchlistPlayer";

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

const requester = new TitarRequester();

const WatchlistWidget = () => {
    const { push } = useSnackbar();
    const [watchlist, setWatchlist] = React.useState(this.window.state.watchlist);
    const [games, setGames] = React.useState({});
    const [lastGames, setLastGames] = React.useState(this.window.state.lastGames);

    const removePlayer = (playerId) => {
        requester.delete(`/watchlist/${playerId}`).then((response) => {
            push({ variant: "success", message: "Player removed from watchlist" });
            setWatchlist((prev) => {
                return prev.filter((player) => player.id !== playerId)
            });
        })
    }

    const updateData = useCallback(() => {
        requester.get('/watchlist/get').then((data) => {
            setWatchlist(data.watchlist);
            setLastGames(data.lastGames);

            setTimeout(() => {
                updateData();
            }, 1000 * 60)
        })
    }, [])

    useEffect(() => {
        // updateData();

    }, [updateData]);

    useEffect(() => {
        console.log('Watchlist updated:', watchlist);
    }, [watchlist]);

    const addPlayerToWatchlist = (data) => {
        console.log(data)
        setWatchlist((prev) => [...prev, data.player].sort((a, b) => a.last_game_at < b.last_game_at ? 1 : -1));
        setLastGames((prev) => ({
            ...prev,
            [data.player.faceit_player_id]: data.lastGame
        }));
    }

    return (
        <React.Fragment>
            <WatchlistSearch onAdd={addPlayerToWatchlist} />
            {watchlist && watchlist.length > 0 ? <GuestWatchlistCTA /> : null}

            <div className="md:hidden flex flex-col gap-3">
                {watchlist?.map((player) => (
                    <WatchlistMobileCard
                        key={player.id}
                        player={player}
                        game={games[player.id] ?? null}
                        lastGame={lastGames?.[player.faceit_player_id]}
                        onRemove={() => removePlayer(player.id)}
                    />
                ))}
            </div>
            <table className="w-full hidden md:table">
                <tbody>
                    {watchlist && watchlist.length > 0 ? watchlist.map((player) => {
                        return <React.Fragment key={player.id}>
                            <tr className="h-2" >
                                <th colspan="9"></th>
                            </tr>
                            <WatchlistPlayer player={player} game={games[player.id] ?? null} onRemove={() => removePlayer(player.id)} setWatchlist={setWatchlist} setGames={setGames} />
                        </React.Fragment>
                    }) : (
                        <p className="mt-6 text-2xl text-center">Your watchlist is empty.<br />Start adding players to track their stats!</p>
                    )}
                </tbody>
            </table >
        </React.Fragment>


    );
}

const el = document.getElementById("watchlist-react");
if (el) {
    const props = {
        watchlist: el.dataset.watchlist,
        lastGames: el.dataset.lastGames,
    };
    createRoot(el).render(<SnackbarProvider>
        <WatchlistWidget {...props} />
    </SnackbarProvider>);
}